module.exports = __webpack_public_path__ + "static/media/Shannon Cassidy.def72265.png";